import { PropTypes as T } from 'prop-types';
import React, { memo } from 'react';

export const getBankAccount = (account) => {
	const { prefix, accountNumber, bankCode } = account;

	let bankAccount = `${accountNumber}/${bankCode}`;

	if (prefix && !!Number(prefix)) {
		bankAccount = `${prefix}-${bankAccount}`;
	}

	return bankAccount;
};

const BankAccount = memo(function BankAccount(props) {
	return <span data-clarity-mask="true">{getBankAccount(props.account)}</span>;
});

BankAccount.propTypes = {
	account: T.shape({
		prefix: T.string,
		accountNumber: T.string.isRequired,
		bankCode: T.string.isRequired,
	}).isRequired,
};

export default BankAccount;
